import React from "react";

import * as S from "./styles";

export const MateriaPrima: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Photo1 />
      </S.Content>
      <S.Content className="bg">
        <S.Photo2 />
        <S.Title>
          Matéria-prima
          <br />
          vegetal
        </S.Title>
        <S.Wrapper>
          <S.Text>
            <p>
              Desde 2018, a WGSN prevê o crescimento do uso de cogumelos como
              composição na produção de novos produtos, assim como o seu aumento
              em massa até 2022. Além de ser usado de forma terapêutica para
              tratamento de doenças como depressão, suas partículas também vêm
              sendo exploradas por{" "}
              <a
                href="https://editorialist.com/beauty/mushroom-skincare/"
                target="_blank"
                rel="noreferrer"
              >
                marcas de beleza
              </a>
              , pois conseguem manter a pele muito mais hidratada do que um
              produto comum.
            </p>
            <p>
              O uso de materiais naturais não é nada novo nesse meio, mas, cada
              vez mais, as marcas estão buscando descartar o couro animal e
              trabalhar apenas com matérias-primas vegetais.
            </p>
          </S.Text>
          <S.Text>
            <p>
              No ano passado, Adidas, Stella McCartney, Lululemon e a holder
              Kering se uniram para investir no desenvolvimento do{" "}
              <a
                href="https://www.mylo-unleather.com/"
                target="_blank"
                rel="noreferrer"
              >
                Mylo
              </a>
              , como é chamado o tecido feito com micélio – a raiz de cogumelos.
              Criado por meio da{" "}
              <a
                href="https://boltthreads.com/"
                target="_blank"
                rel="noreferrer"
              >
                Bolt Threads
              </a>
              , uma empresa focada em materiais biotecnológicos, as parcerias
              começaram a lançar seus frutos este ano.
            </p>
          </S.Text>
        </S.Wrapper>
        <S.PhotosWrapper>
          <S.Photo3 />
          <S.Photo4 />
          <S.Photo5 />
          <S.Credit>Stella Mccartney</S.Credit>
        </S.PhotosWrapper>
      </S.Content>
      <S.Content className="black">
        <S.MobilePhotosWrapper>
          <S.Credit>Stella Mccartney</S.Credit>
          <S.Photo3 />
          <S.Photo4 />
          <S.Photo5 />
        </S.MobilePhotosWrapper>
      </S.Content>
    </S.Container>
  );
};
